import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { MarathonList } from './MarathonList';
import { MarathonDatagrid } from './MarathonDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Marathon } from './Marathon';

export * from './Marathon';
export * from './MarathonCreate';
export * from './MarathonDatagrid';
export * from './MarathonEdit';
export * from './MarathonList';
export * from './MarathonShow';

const MarathonsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'featuredImageUrl', header: 'Featured Image' },
	{ key: 'name', header: 'Name' },
	{ key: 'agenda', header: 'Agenda' },
	{ key: 'duration', header: 'Duration' },
	{ key: 'date', header: 'Date' },
	{ key: 'coach.fullName', header: 'Coach' },
	{ key: 'participantsIds.length', header: 'Participants' }
];

export const MarathonsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Marathon) => entity;

	const marathonsFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('מרתונים', exportFields, exportDataMapper)}
				{...props}
				filters={marathonsFilter}
				bulkActionButtons={<MarathonsBulkActionButtons/>}
				title="MARATHONS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <MarathonList/> : <MarathonDatagrid/>}
			</List>
		</Fragment>
	);
};
